

<template>
  <!--消息中心-->
  <OpDialog
    class="opple-light-elf-dialog step-2"
    :visible="visible"
    :is-show-btn="false"
    @onClose="onClose"
  >
    <div
      class="opple-light-elf"
    >
      <div class="opple-light-elf-lt">
        <div class="opple-light-elf_title" />
        <img :src="LIGHT_ELF_AWAKE_IMAGE">
      </div>
      <div class="opple-light -elf-gt">
        <div class="opple-light-elf_info">
          <p>{{ $t('ifttt.wakePro') }}</p>
        </div>
        <div class="opple-light-elf_btnList">
          <div
            :class="{disabled: isLoadingConfiguration }"
            class="opple-light-elf_btn blue"
            @click="onConfiguration"
          >
            {{ $t('ifttt.aWakened') }}
          </div>
        </div>
      </div>
    </div>
  </OpDialog>
</template>
<script>
import OpDialog from '../../common/OpDialog';

const LIGHT_ELF_AWAKE_IMAGE = 'https://appresource.opple.com/media/business/333972/20260703151723_53.png';

export default {
  components: { 
    OpDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    device: {
      type: Object,
      default: () => null
    },
    Gpno: {
      type: Number,
      default: () => null
    },
    isLoadingConfiguration: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      LIGHT_ELF_AWAKE_IMAGE,
    }
  },

  mounted(){
  },

  created() {
  },

  methods: {
    onClose() {
      this.$emit('onClose');
    },

    onConfiguration() {
      if (this.isLoadingConfiguration) return;

      this.$emit('onOk');
    },
  }
}
</script>

<style lang="scss">
.opple-light-elf-dialog {
  background: #F2F3F5;
  
  .opDialog_body {
    background: #F2F3F5;
  }

  &.step-2 {
    width: 600px;
    min-height: 206px;

    .opDialog_body {
      min-height: 206px;
      max-height: 206px;

      .opple-light-elf {
        padding: 0 28px;

        &-lt {
          img {
            width: 100px;
            height: 100px;
          }
        }

        &_btnList {
          justify-content: flex-end;
        }
      }
    }
  }
}

.opple-light-elf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #F2F3F5;
  padding: 0 90px;

  &-lt {
    // padding-left: 90px;
    // margin-right: 86px;
    img {
      width: 400px;
    }
  }

  &_desc {
    width: 330px;
    font-size: 12px;
    color: #989898;
  }

  &_title {
    margin: 30px 0 40px;
    font-size: 18px;
    line-height: 26px;
    color: #000000;
  }

  &_info {
    margin: 60px 0 40px;
    font-size: 17px;
  }

  &_object {
    box-sizing: border-box;
    width: 347px;
    height: 57px;
    display: flex;
    background: #fff;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px;
    margin: 120px 0 219px;
    transform: translateX(-80px);
    padding-left: 19px;
    padding-right: 58px; 
  }

  &_btnList {
    display: flex;
    align-items: center; 
  }

  &_btn {
    min-width: 143px;
    height: 46px;    
    border-radius: 8px;
    padding: 0 10px;
    white-space: nowrap;
    font-size: 16px;
    line-height: 46px;
    text-align: center;
    cursor: pointer;

    &.grey {
      background: #DDDEDF;
      color: #606060;
      margin-right: 52px;
    }

    &.blue {
      background: #2145A4;
      color: #FFF;

      &.disabled {
        background: #DDDEDF;
        color: #606060;
      }
    }
  }
}
</style>
